'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _handleActions;

import { handleActions, combineActions } from 'flux-actions';
import BookInfo from 'MeetingsBase/models/PublicAvailabilityInfo';
import * as ActionTypes from 'MeetingsLib/redux/actions/ActionTypes';
var initialState = new BookInfo();
export default handleActions((_handleActions = {}, _defineProperty(_handleActions, combineActions(ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED, ActionTypes.PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_SUCCEEDED), function (state, action) {
  return action.payload.bookInfo;
}), _defineProperty(_handleActions, ActionTypes.BOOKING_TIME_CONFLICT, function (state, action) {
  return state.set('linkAvailability', action.payload.linkAvailability);
}), _handleActions), initialState);